import React from 'react'
import PropTypes from 'prop-types'

const SelectComponent =
  ({
    style,
    input_style,
    label,
    type,
    placeholder,
    name,
    value,
    onChange,
    required,
    hidden,
    disabled,
    display,
    options,
  }) => {
    if (hidden) return null; // If hidden is true, skip rendering the input
    return (
      <>
        {display
          ?
          <div className={`${style}`} >
            {label !== "" &&
              <label htmlFor={name} className="form-label" >
                {required && <span className="text-danger"> * </span>}{label}
              </label>
            }
            <select
              className={`${input_style}`}
              placeholder={`Select ${label}`}
              name={name}
              value={value}
              options={options}
              onChange={onChange}
              required={required}
              disabled={disabled}
            >
              {Array.isArray(options) ? (
                options.map((option) => (
                  <option key={option.key || option.value} value={option.value}>
                    {option.label}
                  </option>
                ))
              ) : (
                <option disabled>No options available</option>
              )}
            </select>
          </div>
          :
          <div className={`${style}`} >
            <div className="flex">
              {label !== "" &&
                <div className={`col-md-3`} >
                  <label
                    className="form-label"
                    htmlFor={name}
                  >
                    {required && <span className="text-danger"> * </span>}{label}
                  </label>
                </div>
              }
              <div className={`col-md-9`} >
                <select
                  className={`${input_style}`}
                  options={options}
                  placeholder={`Select ${label}`}
                  name={name}
                  value={value}
                  onChange={onChange}
                  required={required}
                  disabled={disabled}
                >
                  {Array.isArray(options) ? (
                    options.map((option) => (
                      <option key={option.key || option.value} value={option.value}>
                        {option.label}
                      </option>
                    ))
                  ) : (
                    <option disabled>No options available</option>
                  )}
                </select>
              </div>
            </div>
          </div>
        }
      </>
    )
  }
SelectComponent.propTypes = {
  style: PropTypes.string,
  input_style: PropTypes.string,
  label: PropTypes.string,
  type: PropTypes.string,
  placeholder: PropTypes.string,
  name: PropTypes.string.isRequired,
  value: PropTypes.any,
  onChange: PropTypes.func.isRequired,
  required: PropTypes.bool,
  hidden: PropTypes.bool,
  disabled: PropTypes.bool,
  display: PropTypes.bool,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      label: PropTypes.string.isRequired,
    })
  ).isRequired,
}

export default SelectComponent
